import { ActionReducerMap } from '@ngrx/store';
// import { MuniRootReducerState } from '@ipreo/muni-shared';
import { gamedayDataReducer } from './data/reducer';
import { reportsReducer } from './reports/reducer';
// import { ReportsState } from './reports/state';
import { negativeCasesReducer } from './negative-cases/reducer';
// import { NegativeCasesState } from './negative-cases/state';
import { progressBarChartReducer } from './charts/reducer';
// import { ProgressBarChartState } from './charts/state';
import { profileReducer } from './profile/reducer';
// import { ProfileOverviewState } from './profile/state';
import { monitorReducer } from './monitor/reducer';
// import { MonitorState } from './monitor/state';
// import { MarketDrawerRootReducerState } from '../market-drawer/state/reducer';
import { GameDayReducerState } from './gameday.state';

export const gameDayReducerDef: ActionReducerMap<GameDayReducerState> = {
  data: gamedayDataReducer,
  reports: reportsReducer,
  negativeCases: negativeCasesReducer,
  charts: progressBarChartReducer,
  profile: profileReducer,
  monitor: monitorReducer
};
